module.exports = __webpack_public_path__ + "img/tour-standing.c6b3084f.svg";